/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'waiting_feedback': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12.14 19.393l-.375.01-.218.305-1.405 1.977-1.426-2.106-.223-.329H3a.25.25 0 01-.25-.25V8A.25.25 0 013 7.75h14a.25.25 0 01.25.25v11.024a.25.25 0 01-.244.25l-4.866.12z" _stroke="currentColor" stroke-width="1.5"/><path pid="1" d="M6 8V5a1 1 0 011-1h13a1 1 0 011 1v10a1 1 0 01-1 1h-2.97" _stroke="currentColor" stroke-width="1.5"/><path pid="2" fill-rule="evenodd" clip-rule="evenodd" d="M11.232 12.836L9.96 11.521l1.078-1.042 3.022 3.126-3.04 2.935-1.042-1.08 1.164-1.124H6v-1.5h5.232z" _fill="currentColor"/>'
  }
})
